// eslint-disable-next-line import/no-duplicates
import Swiper from 'swiper';
// eslint-disable-next-line import/no-duplicates
import SwiperCore, { Thumbs } from 'swiper/core';

SwiperCore.use([Thumbs]);


export default function initImageGallery() {
  const $container = document.querySelector('.cp-image-gallery');
  let $activeSlide = 0;
  if (!$container) {
    return;
  }

  const $credits = document.querySelectorAll('.credit-symbol');
  $credits.forEach(($credit) => {
    $credit.addEventListener('click', (event) => {
      event.stopPropagation();


      const elements = document.querySelectorAll(`.credit-${$activeSlide}`);


      elements.forEach((element) => {
        if (element.classList.contains('show')) {
          element.classList.remove('show');
          element.parentNode.classList.remove('-background');
        } else {
          element.classList.add('show');
          element.parentNode.classList.add('-background');
        }
      })
    });
  });

  const $closes = document.querySelectorAll('.credit-close');
  $closes.forEach(($close) => {
    $close.addEventListener('click', (event) => {
      event.stopPropagation();
      const $swipers = document.querySelectorAll('.swiper-main-image');
      $swipers.forEach((swiperMain, index) => {
        const { swiper } = document.querySelector(
          `#swiper-thumbnails-${index}`,
        );
        const element = document.querySelector(`.credit-container.credit-${swiper.activeIndex}`);
        if (element.classList.contains('show')) {
          element.parentNode.classList.remove('-background')
          element.classList.remove('show');
        }
      });
    });
  });


/* eslint-disable */
const $swipers = document.querySelectorAll('.swiper-main-image')
$swipers.forEach((swiperMain, index) => {
    // Set ID of Main swiper and Thumbnails swiper for multiple swiper in same page
    swiperMain.setAttribute('id', `swiper-main-image-${index}`);
    const swiperThumbails = swiperMain.nextElementSibling
    swiperThumbails.setAttribute('id', `swiper-thumbnails-${index}`)
    
    // Set Number of Thumbails
    const numberOfThumbs = parseInt(swiperThumbails.getAttribute('data-number')) || 4;

    const swiper = new Swiper(`#swiper-thumbnails-${index}`, {
      spaceBetween: 27,
      slidesPerView: numberOfThumbs,
      freeMode: true,
      watchSlidesProgress: true,
    });

    

    const test = new Swiper(swiperMain, {
        navigation: {
            nextEl: '.js-image-gallery-button-next',
            prevEl: '.js-image-gallery-button-prev',
        },
        spaceBetween: 17,
        thumbs: {
            swiper,
        },
    
    });
    test.on("transitionEnd", el => {
      $activeSlide = el.activeIndex;
    });
})

/* eslint-enable */
}
